<template>
  <StandardFlexBox
    width="100%"
    height="100%"
    style="padding: 2px"
    >

    <TMoveToDialog 
      v-if="prefix !== 'b' && prefix !== 'c' && move_to_element" 
      :folders="getWBObjects({ type: 'sfolders' })" 
      :current_folder="current_folder" 
      :item="move_to_element"
      :item_type="move_to_element_type"
      folder_type="sfolder"
      @cancel="move_to_element = false;"
      @move="moveSFolder($event)"
    />

    <transition name="dialog_slide">
      <router-view style="z-index: 20"/>
    </transition>
    <template>
    <div class="workbench-search-wrapper">
      <div class="workbench-search-wrapper-top">
          <!-- left part -->
          <div class="workbench-search-wrapper-top-left">
            <div v-if="prefix !== 'b' && prefix !== 'c' && current_folder" class="folder-breadcrumbs">
              <TBreadcrumbs 
                  :breadcrumbs="folder_breadcrumbs"
                  root_name="Home"
                  :is_root="active_sfolder_id === 'last-updated'"
                  :current_folder_name="current_folder.name"
                  @clickRoot="$router.push({
                  name: `${location}Sequences`,
                  params: {
                    sfolder: 'last-updated',
                  }})"  
                  @clickBreadcrumb="$router.push({
                  name: `${location}Sequences`,
                  params: {
                    sfolder: $event.id,
                  }})"
                />
            </div>

          </div>
          <!-- right part -->
          <div class="workbench-search-wrapper-top-right">
            <v-progress-circular v-if="$store.state.WorkBenchLocal.workbench_variables.loading" indeterminate color="primary"/>
  
            <DropDown
              :items="filter_options"
              :value="$store.state.View.workbench_sorting"
              placeholder="Sorting"
              :translatable="true"
              :max_width="190"
              foreground_color="primary"
              :light="!$vuetify.theme.dark"
              @selected="updateWorkbenchSorting($event)"
            />
            <TIconButton
              v-if="$route.params.template_type === 'custom'"
              :color="$store.state.WorkBenchLocal.workbench_variables.search_all ? 'green': ''"
              tooltip="Search all subfolders"
              @clickIcon="updateSearchType()"
              icon="folder"
            />
            <SearchBar
              :is_live_emit="true"
              placeholder="Search for sequences"
              max_width="200"
              underscored
              @search="$event && $event != ''
                ? workbenchSearch($event): resetSearchBar()"
            />
          </div>


      </div>
      <template v-if="workbench_variables.search === ''">
        <TText
          size="18"
          font_weight="600"
          :value="displayNoSearch"
        />
      </template>
      <template v-else>
        <TText
          size="18"
          font_weight="600"
          :value="'Search result{symbol} {searchVal}'"
          :value_props="{symbol: ':', searchVal: workbench_variables.search}"
        />
      </template>
    </div>
    </template>
    <!-- NOTE: this does not work as is! icons are way too large -->
    <template v-if="workbench_variables.items_mini">

      <!-- Folder area -->
      <div class="mt-2 mb-2 pb-5" style="display:flex;">
        <TContextMenu 
          :menu_items="[{key: 'rename', text: 'Rename'}, {key: 'move', text: 'Move'}, {key: 'delete', text: 'Delete', icon: 'bin-delete'}]" 
          v-for="(sfolder) in sfolders" 
          :key="`sfolder${sfolder.id}`" 
          @selectMenuItem="selectMenutItemSFolder($event, sfolder)"
        >
          <TFolder 
            :folder="sfolder" 
            prefix="" 
            :ref="`sfolder_${sfolder.id}`" 
            @click.native.stop="$router.push({
              name: `${location}Sequences`,
              params: {
                sfolder: sfolder.id,
              }})" 
            @renameFolder="renameFolder($event)" />
        </TContextMenu>
      </div>


      <!-- ['sequences', 'csequences', 'bsequences']: -->
      <TContextMenu 
        :menu_items="[{key: 'move', text: 'Move'}]" 
        v-for="sequence in sequences_sorted"
        :key="`${sequence.template_type}${sequence.id}`"
        @selectMenuItem="selectMenutItemSequence($event, sequence)"
      >
        <SequencePicker
          class="ma-1 pa-2 t-rounded"
          :template_type="sequence.template_type"
          width="390px"
          @click.native="$router.push({
              name: `${location}SequenceEditor`,
              params: {
                sequence_id: sequence.id,
              }
            })"
          >
          <template #header>
            <div style="display: flex; flex-direction:column">
              <TText :text="sequence.name" font_weight="400" size="13"/>
             <TText v-if="sequence.sfolder ? sequence.sfolder.id != active_sfolder_id : false" :text="sequence.sfolder.name" font_weight="300" size="9" align="center" />
            </div>
           </template>
          <template #sequence>
            <TrainHead :zoom="0.4"/>
            <v-hover
              v-for="waggon in getWBObjects({type: `${prefix}swaggons`, ids: sequence[`${prefix}swaggons`]})"
              :key="`${prefix}swaggons${waggon.id}`"
              >
              <template #default="{hover}">
                <Waggon
                  :zoom="0.4"
                  :workpackage_count="waggon[`${prefix}sworkpackages`].length"
                  :style="
                  `transition: margin-right 0.1s ease-in-out;
                  margin-right: ${hover? '0px':'-10px'}
                  `
                  "
                  >
                  <template #content>
                    <WorkPackage
                      v-for="workpackage in getWBObjects({type: `${prefix}sworkpackages`, ids: waggon[`${prefix}sworkpackages`]})"
                      :key="workpackage.id"
                      :workpackage_count="waggon[`${prefix}sworkpackages`].length"
                      :workpackage="workpackage"
                      :zoom="0.4"
                      />
                    </template>
                </Waggon>
              </template>
            </v-hover>
            <TrainTail :zoom="0.4"/>
          </template>
        </SequencePicker>
      </TContextMenu>
    </template>

    <template v-else>
      <div class="workbench-search-content">

        <!-- Folder area -->
        <div class="mt-2 mb-2 pb-5" style="display:flex;">
          <TContextMenu 
            :menu_items="[{key: 'rename', text: 'Rename'}, {key: 'move', text: 'Move'}, {key: 'delete', text: 'Delete', icon: 'bin-delete'}]" 
            v-for="(sfolder) in sfolders" 
            :key="`sfolder${sfolder.id}`" 
            @selectMenuItem="selectMenutItemSFolder($event, sfolder)"
          >
          <!-- :parent="sfolder.sfolder.id == active_sfolder_id ? false : sfolder.sfolder" -->
            <TFolder 
              :folder="sfolder"
              :parent="sfolder.sfolder ? (sfolder.sfolder.id == active_sfolder_id ? false : sfolder.sfolder) : false"
              prefix="" 
              :ref="`sfolder_${sfolder.id}`" 
              @click.native.stop="$router.push({
                name: `${location}Sequences`,
                params: {
                  sfolder: sfolder.id,
                }})" 
              @renameFolder="renameFolder($event)" />
          </TContextMenu>
        </div>


        <TContextMenu 
          :menu_items="[{key: 'move', text: 'Move'}]" 
          v-for="sequence in sequences_sorted"
          :key="`sequence_id${sequence.id}`"
          @selectMenuItem="selectMenutItemSequence($event, sequence)"
        >
          <v-hover
 
            >
            <template #default="hover_sequence">
              <WorkBenchSequence
                class="cursor-pointer"
                :key="`${sequence.template_type}${sequence.id}`"
                :template_type="sequence.template_type"
                @click.native="$router.push({
                    name: `${location}SequenceEditor`,
                    params: {
                      sequence_id: sequence.id,
                    }
                  })"
                >
                <template #info-header>
                  <div style="display: flex; flex-direction: column;">
                    <TText :text="sequence.name" font_weight="400" size="13" align="center" />
                    <TText v-if="sequence.sfolder ? sequence.sfolder.id != active_sfolder_id : false" :text="'/' + sequence.sfolder.name" font_weight="300" size="9" align="center" />
                  </div>
                  <v-spacer/>
                  <StandardBadge
                    v-if="sequence.template_type && sequence.template_type !== 'custom'"
                    :icon="sequence.template_type === 'community'?'persons-two':'suitcase'"
                    :zoom="1"
                    style="top: 7px; right: 7px"
                    color="white"
                    content_color="black"
                  />
                </template>
                <template #info-content>
                  <TFlex
                    justify_content="space-around"
                    >
                    <v-hover>
                      <template #default="hover_circle">
                      <TProgressCircle
                        :diameter="36"
                        :width="4"
                        :color="$vuetify.theme.isDark ? '255,255,255' : '0,0,0'"
                        :data="sequencePreviewStatistics[`${prefix}sequences`][sequence.id].steps"
                        :show_icons="hover_sequence.hover"
                        :show_values="hover_circle.hover"
                        />
                      </template>
                    </v-hover>
                    <v-hover>
                      <template #default="hover_circle">
                        <TProgressCircle
                          :diameter="36"
                          :width="4"
                          :color="$vuetify.theme.isDark ? '255,255,255' : '0,0,0'"
                          :data="sequencePreviewStatistics[`${prefix}sequences`][sequence.id].images"
                          :show_icons="hover_sequence.hover"
                          :show_values="hover_circle.hover"
                          />
                      </template>
                    </v-hover>
                    <TProgressCircle
                      :diameter="36"
                      :width="4"
                      :color="$vuetify.theme.isDark ? '255,255,255' : '0,0,0'"
                      :data="sequencePreviewStatistics[`${prefix}sequences`][sequence.id].values"
                      :show_icons="hover_sequence.hover"
                      />
                  </TFlex>
                </template>
                <template #info-footer>
                  <div>{{sequence.updated.substring(0,16)}}</div>
                  <div>{{sequence.owner.email}}</div>
                </template>
                <template #content-statistics>
                  <div style="width: 62px; flex-shrink: 0"/>
                  <v-hover
                    v-for="(waggon, index) in sequencePreviewStatistics[`${prefix}sequences`][sequence.id].waggons"
                    :key="`waggonindex${index}`"
                    >
                    <template #default="{hover}">
                      <TFlex
                        :key="`sequence${sequence.id}waggon${index}`"
                        width="calc(var(--workpackage_width) + 8px)"
                        height="100%"
                        style="flex-shrink: 0"
                        >
                        <StatisticsTakt width="calc(100% / 3)">
                          <StatisticsBeamTaktSum v-if="!hover" height="14px">{{waggon.steps.percentage > 0?`${parseInt(waggon.steps.percentage)}%`:''}}</StatisticsBeamTaktSum>
                          <StatisticsBeamTaktSum v-else-if="!hover_sequence_steps_beam_icon" height="14px">{{waggon.steps.total > 0?`${parseInt(waggon.steps.total)}`:''}}</StatisticsBeamTaktSum>
                          <StatisticsBeamTaktSum v-else height="14px"><svg-icon size="10" :name="hover_sequence_steps_beam_icon"/></StatisticsBeamTaktSum>
                          <template v-for="(wp, wp_index) in waggon.wps">
                            <template v-for="segment in wp.steps.segments">
                            <StatisticsBeam
                              :key="`sequence${sequence.id}waggon${index}${wp_index}${segment.icon}`"
                              :color="wp.color"
                              :value="!hover?(segment.value?1:0):segment.count"
                              :max_value="!hover?waggon.wps_count * 6:waggon.steps.total"
                              no_zoom="true"
                              no_text="true"
                              takt_sum_height="14px"
                              :margin_top="segment.value?'1px':false"
                              :wps_count="waggon.wps_count"
                              @mouseenter.native="hover_sequence_steps_beam_icon = segment.icon"
                              @mouseleave.native="hover_sequence_steps_beam_icon = false"
                              />
                            </template>
                          </template>
                        </StatisticsTakt>
                        <StatisticsTakt width="calc(100% / 3)">
                          <StatisticsBeamTaktSum v-if="!hover" height="14px">{{waggon.images.percentage > 0?`${parseInt(waggon.images.percentage)}%`:''}}</StatisticsBeamTaktSum>
                          <StatisticsBeamTaktSum v-else-if="!hover_sequence_images_beam_icon" height="14px">{{waggon.images.total > 0?`${parseInt(waggon.images.total)}`:''}}</StatisticsBeamTaktSum>
                          <StatisticsBeamTaktSum v-else height="14px"><v-icon size="10">{{hover_sequence_images_beam_icon}}</v-icon></StatisticsBeamTaktSum>
                          <template v-for="(wp, wp_index) in waggon.wps">
                            <template v-for="segment in wp.images.segments">
                            <StatisticsBeam
                              v-if="segment.value"
                              :key="`sequence${sequence.id}waggon${index}${wp_index}${segment.icon}`"
                              :color="wp.color"
                              :value="!hover?(segment.value?1:0):segment.count"
                              :max_value="!hover?waggon.wps_count * 1:waggon.images.total"
                              no_zoom="true"
                              no_text="true"
                              takt_sum_height="14px"
                              :margin_top="segment.value?'1px':false"
                              :wps_count="waggon.wps_count"
                              @mouseenter.native="hover_sequence_images_beam_icon = 'image'"
                              @mouseleave.native="hover_sequence_images_beam_icon = false"
                              />
                            </template>
                          </template>
                        </StatisticsTakt>
                        <StatisticsTakt width="calc(100% / 3)">
                          <StatisticsBeamTaktSum v-if="!hover || hover && !hover_sequence_values_beam_icon" height="14px">{{waggon.values.percentage > 0?`${parseInt(waggon.values.percentage)}%`:''}}</StatisticsBeamTaktSum>
                          <StatisticsBeamTaktSum v-else-if="hover_sequence_values_beam_icon" height="14px"><v-icon size="10">{{hover_sequence_values_beam_icon}}</v-icon></StatisticsBeamTaktSum>
                          <template v-for="(wp, wp_index) in waggon.wps">
                            <template v-for="(segment, seg_index) in wp.values.segments">
                            <StatisticsBeam
                              v-if="segment.value"
                              :key="`sequence${sequence.id}waggon${index}${wp_index}${seg_index}`"
                              :color="wp.color"
                              :value="1"
                              :max_value="waggon.wps_count * 6"
                              no_zoom="true"
                              no_text="true"
                              takt_sum_height="14px"
                              margin_top="1px"
                              :wps_count="waggon.wps_count"
                              @mouseenter.native="hover_sequence_values_beam_icon = segment.icon"
                              @mouseleave.native="hover_sequence_values_beam_icon = false"
                              />
                            </template>
                          </template>
                        </StatisticsTakt>
                      </TFlex>
                    </template>
                  </v-hover>
                </template>
                <template #content-sequence>
                  <TrainHead :zoom="1" style="flex-shrink: 0"/>
                  <Waggon
                    v-for="waggon in getWBObjects({type: `${prefix}swaggons`, ids: sequence[`${prefix}swaggons`]})"
                    :key="`${prefix}swaggons${waggon.id}`"
                    :zoom="1"
                    :workpackage_count="waggon[`${prefix}sworkpackages`].length"
                    style="flex-shrink: 0"
                    >
                    <template #content>
                      <WorkPackage
                        v-for="workpackage in getWBObjects({type: `${prefix}sworkpackages`, ids: waggon[`${prefix}sworkpackages`]})"
                        :key="workpackage.id"
                        :workpackage_count="waggon[`${prefix}sworkpackages`].length"
                        :workpackage="workpackage"
                        :zoom="1"
                        />
                      </template>
                  </Waggon>
                  <TrainTail :zoom="1" style="flex-shrink: 0"/>
                </template>
              </WorkBenchSequence>
            </template>
          </v-hover>
        </TContextMenu>
      </div>
    </template>
  </StandardFlexBox>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { WorkBenchMixin } from '@/mixins/WorkBench.mixin.js';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import TFolder from '@/components/Taktify/TFolder.component.vue';
import TIconButton from '@/components/Taktify/TIconButton.component.vue';
import TMoveToDialog from '@/components/Taktify/TMoveToDialog.component.vue';
import TBreadcrumbs from '@/components/Taktify/TBreadcrumbs.component.vue';
import TContextMenu from '@/components/Taktify/TContextMenu.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';

  export default {
    props: [
      'location'
    ],

    mixins: [
      WorkBenchMixin,
      WorkPackageWIPMixin,
    ],

    components: {
      SearchBar,
      TFolder,
      DropDown,
      TContextMenu,
      TMoveToDialog,
      TBreadcrumbs,
      TIconButton
    },

    data: () => ({
      move_to_element: false,
      move_to_element_type: 'sfolders',
      filter_options: [
        'Updated date (asc)',
        'Updated date (desc)',
        'Created date (asc)',
        'Created date (desc)',
        'Name (asc)',
        'Name (desc)'
      ],
    }),

    beforeRouteLeave(to, from, next){
      this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search: ''
          }
        });
        next();
    },

    created() {
      this.loadData(`&limit=8&offset=0`);
    },

    computed: {

      ...mapGetters('WorkBench', [
        'getParentFolders',
        'getWBObject',
      ]),

      displayNoSearch() {
        if(this.$store.state.WorkBench.all_loaded.includes(`${this.prefix}workpackages`)) {
          return 'All';
        }

        return this.$store.state.View.workbench_sorting;
      },
      
      active_sfolder_id(){
        const active_sfolder_id = this.$route.params.sfolder;
        if(active_sfolder_id === 'last-updated') {
          return active_sfolder_id
        }
        return parseInt(active_sfolder_id);
      },

      current_folder(){
        if (this.active_sfolder_id === 'last-updated') {
          return { name: 'Home', id: 'last-updated' };
        }
        return this.getWBObject({ type: 'sfolders', id: this.active_sfolder_id });
      },

      folder_breadcrumbs(){
        if (this.active_sfolder_id === 'last-updated') {
          return [];
        }
        const wb_object = this.current_folder;
        if (!wb_object) {
          return [];
        }
        return this.getParentFolders({type: 'sfolder', wb_object: wb_object}).reverse();
      },  

      sfolders(){
        // console.log(this.prefix)
        if (this.prefix !== 'b' && this.prefix !== 'c') {
          return this.getWBObjectsSearch({prefix: this.prefix, object_type: 'sfolders',object_type_short: 's', folder: this.active_sfolder_id});
        }
        return [];
      },

      sequences_sorted() {
        let seq = this.getWBObjectsSearch({prefix: this.prefix, object_type: 'sequences', object_type_short: 's', folder: this.active_sfolder_id});
        let sort_by;
        let reverse;
        switch (this.$store.state.View.workbench_sorting) {
          case 'Created date (asc)':
            sort_by = 'created';
            reverse = false;
            break;
          case 'Created date (desc)':
            sort_by = 'created';
            reverse = true;
            break;
          case 'Updated date (asc)':
            sort_by = 'updated';
            reverse = false;
            break;
          case 'Updated date (desc)':
            sort_by = 'updated';
            reverse = true;
            break;
          case 'Name (asc)':
            sort_by = 'name';
            reverse = false;
            break;
          case 'Name (desc)':
            sort_by = 'name';
            reverse = true;
            break;
          default:
            sort_by = 'updated';
        }

        this.sortObjectArrayByValueOfKey(seq, sort_by);

        if(reverse) seq.reverse();

        return seq;
      },
    },

    watch: {
      prefix() {
        this.loadData(`&limit=8&offset=0`);
      }
    },

    methods: {
      ...mapActions('View', [
        'setValue',
      ]),

      updateWorkbenchSorting(sorting) {
        localStorage.setItem('Workbench_Sorting', sorting);
        this.setValue({ key: 'workbench_sorting', value: sorting });
      },

      workbenchSearch(val){
        if (val && val !== '') {
          this.loadData(`&search=${encodeURIComponent(val)}`).then(() => {
            this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              search: val
            }
          })
          });
        }
      },

      selectMenutItemSFolder(payload, sfolder){
        const item = payload.item;
        if (item.key === 'rename') {
          const folder = this.$refs[`sfolder_${sfolder.id}`][0];
          folder.startRenaming();
        } else if (item.key === 'delete') {
          this.deleteWBObject({
            url: [
              { sfolders: sfolder.id}
            ]
          });
        } else if (item.key === 'move') {
          this.move_to_element = sfolder;
          this.move_to_element_type = 'sfolders';
        }
      },

      selectMenutItemSequence(payload, sequence){
        const item = payload.item;
        if (item.key === 'move') {
          this.move_to_element = sequence;
          this.move_to_element_type = 'sequences';
        }
      },

      moveSFolder(payload){
        this.changeWBObjectFolder({
          url: [
            { [this.move_to_element_type]: payload.target.id }
          ],
          url_suffix: '/changeparent',
          update: {
            parent_id: payload.new_parent.id,
            folder_key: 'sfolders',
          }
        }).then(() => {
          this.move_to_element = false;
        });
      },

      renameFolder(folder){
        this.updateWBObject({
          url: [
            { [`${this.prefix}sfolders`]: folder.id }
          ],
          update: {
            name: folder.name
          }
        });
      },

      loadData(url_suffix){
        return new Promise((resolve) => {
          this.updateWBLObject({
            path: [
              {workbench_variables: ''}
            ],
            update: {
              loading: true
            }
          });
          // if (['b', 'c'].includes(this.prefix) || this.isWBObjEmpty('sequences')) {
            let promises = [];
            promises.push(this.requestWBObject({
              url: [
                {[`${this.prefix}sequences`]: ''},
                {showWithEntitiesNormalized: ''}
              ],
              url_suffix: url_suffix
            }));
            if(this.prefix !== 'b' && this.prefix !== 'c'){
              promises.push(this.requestWBObject({
                url: [
                  {[`${this.prefix}sfolders`]: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                url_suffix: url_suffix
              }));
            }
            Promise.all(promises).then(() => {
              this.updateWBLObject({
                path: [
                  {workbench_variables: ''}
                ],
                update: {
                  loading: false
                }
              });
              resolve();
            });
          // }
        });
      },

      updateSearchType() {
        this.updateWBLObject({
          path: [
            {workbench_variables: ''}
          ],
          update: {
            search_all: !this.$store.state.WorkBenchLocal.workbench_variables.search_all
          }
       })
        localStorage.setItem('WORKBENCH_search_all_subfolders', JSON.stringify(this.$store.state.WorkBenchLocal.workbench_variables.search_all));
      }
    }
  }
</script>
<style scoped>
.workbench-search-wrapper {
  width: 100%;
  padding: 20px 8px;
  background-color: var(--v-color-7-base);
  height: 120px;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.workbench-search-wrapper-top {
  width: 100%;
  display: flex;
  justify-content: space-between;;
  max-height: 40px;
  grid-gap: 16px;
}
.workbench-search-wrapper-top-left {
    display: flex;
    justify-content: flex-start;
}

.workbench-search-wrapper-top-right {
  display: flex;
  justify-content: flex-end;
}
.workbench-search-wrapper-searchbar {
  width: 50%;
  height: 40px;
  align-self: center;
}
.workbench-search-content {
  height: calc(100% - 120px);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}

.folder-breadcrumbs{
  display: flex;
  align-items: center;
}
</style>
